import { render, staticRenderFns } from "./TabProposalsEdit.vue?vue&type=template&id=4969e5b7&"
import script from "./TabProposalsEdit.vue?vue&type=script&lang=js&"
export * from "./TabProposalsEdit.vue?vue&type=script&lang=js&"
import style0 from "./TabProposalsEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports